import React, { useEffect, useState } from 'react';
import SolutionForm from ':src/components/SolutionForm';
import apiFetch from ':src/utils/apiFetch';
import { Solution } from ':src/types';
import SolutionsList from './SolutionsList';

export type SolutionsTabProps = { questionSlug: string };

export default function SolutionsTab({ questionSlug }: SolutionsTabProps) {
  const [mySolutions, setMySolutions] = useState<Solution[]>([]);
  const [communitySolutions, setCommunitySolutions] = useState<Solution[]>([]);

  useEffect(() => {
    void (async () => {
      const [solutions, newMySolutions] = await Promise.all([
        apiFetch<Solution[]>(`solutions?question_slug=${questionSlug}`),
        apiFetch<Solution[]>(`my-solutions?question_slug=${questionSlug}`),
      ]);
      setMySolutions(newMySolutions!);
      setCommunitySolutions(solutions!);
    })();
  }, [questionSlug]);

  return (
    <>
      <div className="mb-12">
        <SolutionForm questionSlug={questionSlug} />
      </div>
      <div className="mb-12">
        <SolutionsList
          className="space-y-6"
          emptyStateText="You haven’t submitted any solutions for this question yet."
          label="Your solutions"
          solutions={mySolutions}
        />
      </div>
      <SolutionsList
        className="space-y-6"
        emptyStateText="There are no community solutions for this question yet."
        label="Community solutions"
        solutions={communitySolutions}
      />
    </>
  );
}
